import { useEffect, useRef, useState } from 'react';

const messages = {
  DELIVERY_RATE_LIMITED: 'Too many requests. Please wait before trying again.',
  DELIVERY_DESTINATION_NOT_FOUND: 'This address is unavailable. Select another address.',
  INVALID_DELIVERY_DESTINATION: 'Please select a valid address from the suggestions.',
  INVALID_PLACES_REQUEST: 'Please enter a valid address search.',
  DELIVERY_OUT_OF_RANGE: 'This address is outside the delivery area. Choose another address.',
  MIN_ORDER_NOT_MET: 'Delivery minimum order has not been met. Add items and try again.',
  DELIVERY_DISABLED: 'Delivery is unavailable for this restaurant. Choose another order type.',
  INVALID_DELIVERY_SETTINGS: 'Delivery is unavailable for this restaurant. Choose another order type.',
  INVALID_CHECKOUT_CONFIGURATION: 'Checkout is currently unavailable.',
  INVALID_SERVICE_CHARGE_SETTINGS: 'Checkout is currently unavailable.',
  DELIVERY_ROUTE_STALE: 'This delivery quote needs refreshing.',
  RESTAURANT_UNAVAILABLE: 'This restaurant is currently unavailable.',
  DELIVERY_PROVIDER_RATE_LIMITED: 'Address lookup is busy. Please try again later.',
  DELIVERY_ROUTE_UNAVAILABLE: 'Delivery lookup is unavailable. Please try again.',
  DELIVERY_PROVIDER_TIMEOUT: 'Delivery lookup timed out. Please try again.',
  INVALID_PLACE_DETAILS: 'The address could not be verified. Search again.',
  INVALID_PLACE_SUGGESTIONS: 'Address suggestions could not be verified. Try again.',
  INVALID_PROVIDER_RESPONSE: 'Delivery lookup could not be verified. Try again.',
  DELIVERY_PROVIDER_REJECTED: 'Delivery lookup could not be completed.',
  INVALID_DELIVERY_ROUTE: 'The delivery route could not be verified.',
  DELIVERY_ROUTE_REQUIRED: 'The delivery route could not be verified.',
};
const PICKER_COPY = {
  en: {
    address: 'Delivery address',
    cooling: 'Please wait before another delivery request.',
    searching: 'Searching addresses…',
    finalizing: 'Verifying address…',
    accepted: 'Delivery address selected.',
    empty: 'No addresses found. Try another search.',
    prompt: 'Type at least 3 characters and select an address.',
    retry: 'Retry address search'
  },
  ar: {
    address: 'عنوان التوصيل',
    cooling: 'يرجى الانتظار قبل إرسال طلب توصيل آخر.',
    searching: 'جارٍ البحث عن العناوين…',
    finalizing: 'جارٍ التحقق من العنوان…',
    accepted: 'تم اختيار عنوان التوصيل.',
    empty: 'لم يتم العثور على عناوين. جرّب بحثًا آخر.',
    prompt: 'اكتب 3 أحرف على الأقل ثم اختر عنوانًا.',
    retry: 'إعادة البحث عن العنوان'
  },
  ms: {
    address: 'Alamat penghantaran',
    cooling: 'Sila tunggu sebelum membuat permintaan penghantaran yang lain.',
    searching: 'Sedang mencari alamat…',
    finalizing: 'Sedang mengesahkan alamat…',
    accepted: 'Alamat penghantaran dipilih.',
    empty: 'Tiada alamat ditemui. Cuba carian lain.',
    prompt: 'Taip sekurang-kurangnya 3 aksara dan pilih alamat.',
    retry: 'Cuba cari alamat semula'
  }
};

const PICKER_ERROR_DISPLAY = [
  [messages.DELIVERY_RATE_LIMITED,
    'طلبات كثيرة جدًا. يرجى الانتظار قبل المحاولة مرة أخرى.',
    'Terlalu banyak permintaan. Sila tunggu sebelum mencuba lagi.'],
  [messages.DELIVERY_DESTINATION_NOT_FOUND,
    'هذا العنوان غير متاح. اختر عنوانًا آخر.',
    'Alamat ini tidak tersedia. Pilih alamat lain.'],
  [messages.INVALID_DELIVERY_DESTINATION,
    'يرجى اختيار عنوان صالح من الاقتراحات.',
    'Sila pilih alamat yang sah daripada cadangan.'],
  [messages.INVALID_PLACES_REQUEST,
    'يرجى إدخال بحث صالح عن عنوان.',
    'Sila masukkan carian alamat yang sah.'],
  [messages.DELIVERY_OUT_OF_RANGE,
    'هذا العنوان خارج نطاق التوصيل. اختر عنوانًا آخر.',
    'Alamat ini di luar kawasan penghantaran. Pilih alamat lain.'],
  [messages.MIN_ORDER_NOT_MET,
    'لم يتحقق الحد الأدنى لطلب التوصيل. أضف منتجات وحاول مجددًا.',
    'Pesanan minimum untuk penghantaran belum dicapai. Tambah item dan cuba lagi.'],
  [messages.DELIVERY_DISABLED,
    'التوصيل غير متاح لهذا المطعم. اختر طريقة طلب أخرى.',
    'Penghantaran tidak tersedia untuk restoran ini. Pilih jenis pesanan lain.'],
  [messages.INVALID_DELIVERY_SETTINGS,
    'التوصيل غير متاح لهذا المطعم. اختر طريقة طلب أخرى.',
    'Penghantaran tidak tersedia untuk restoran ini. Pilih jenis pesanan lain.'],
  [messages.INVALID_CHECKOUT_CONFIGURATION,
    'إتمام الطلب غير متاح حاليًا.',
    'Daftar keluar tidak tersedia buat masa ini.'],
  [messages.INVALID_SERVICE_CHARGE_SETTINGS,
    'إتمام الطلب غير متاح حاليًا.',
    'Daftar keluar tidak tersedia buat masa ini.'],
  [messages.DELIVERY_ROUTE_STALE,
    'يحتاج عرض سعر التوصيل إلى تحديث.',
    'Sebut harga penghantaran perlu dikemas kini.'],
  [messages.RESTAURANT_UNAVAILABLE,
    'هذا المطعم غير متاح حاليًا.',
    'Restoran ini tidak tersedia buat masa ini.'],
  [messages.DELIVERY_PROVIDER_RATE_LIMITED,
    'البحث عن العناوين مشغول. حاول لاحقًا.',
    'Carian alamat sedang sibuk. Sila cuba lagi kemudian.'],
  [messages.DELIVERY_ROUTE_UNAVAILABLE,
    'خدمة التحقق من التوصيل غير متاحة. حاول مرة أخرى.',
    'Semakan penghantaran tidak tersedia. Sila cuba lagi.'],
  [messages.DELIVERY_PROVIDER_TIMEOUT,
    'انتهت مهلة البحث عن التوصيل. حاول مرة أخرى.',
    'Semakan penghantaran mengambil masa terlalu lama. Sila cuba lagi.'],
  [messages.INVALID_PLACE_DETAILS,
    'تعذّر التحقق من العنوان. ابحث مرة أخرى.',
    'Alamat tidak dapat disahkan. Cari semula.'],
  [messages.INVALID_PLACE_SUGGESTIONS,
    'تعذّر التحقق من اقتراحات العناوين. حاول مرة أخرى.',
    'Cadangan alamat tidak dapat disahkan. Cuba lagi.'],
  [messages.INVALID_PROVIDER_RESPONSE,
    'تعذّر التحقق من بيانات خدمة التوصيل. حاول مرة أخرى.',
    'Respons perkhidmatan penghantaran tidak dapat disahkan. Cuba lagi.'],
  [messages.DELIVERY_PROVIDER_REJECTED,
    'تعذّر إكمال البحث عن التوصيل.',
    'Semakan penghantaran tidak dapat diselesaikan.'],
  [messages.INVALID_DELIVERY_ROUTE,
    'تعذّر التحقق من مسار التوصيل.',
    'Laluan penghantaran tidak dapat disahkan.'],
  [messages.DELIVERY_ROUTE_REQUIRED,
    'تعذّر التحقق من مسار التوصيل.',
    'Laluan penghantaran tidak dapat disahkan.'],
  ['Address search is unavailable. Please try again.',
    'البحث عن العناوين غير متاح. حاول مرة أخرى.',
    'Carian alamat tidak tersedia. Cuba lagi.'],
  ['The address could not be verified. Search again.',
    'تعذّر التحقق من العنوان. ابحث مرة أخرى.',
    'Alamat tidak dapat disahkan. Cari semula.']
];

export const localizedPickerError = (safeMessage, language) => {
  if (language !== 'ar' && language !== 'ms') return safeMessage;
  const entry = PICKER_ERROR_DISPLAY.find(([english]) => english === safeMessage);
  if (entry) return entry[language === 'ar' ? 1 : 2];
  return language === 'ar'
    ? 'تعذّر إكمال الطلب. حاول مرة أخرى.'
    : 'Permintaan tidak dapat diselesaikan. Sila cuba lagi.';
};

export const deliveryErrorMessage = code => messages[code] || 'Unable to complete this request. Please try again.';
export const validPlaceId = value => typeof value === 'string' && value.length > 0 && value.length <= 512 &&
  value !== '.' && value !== '..' && !/[\s/\\?#\u0000-\u001f\u007f-\u009f]/.test(value);
export const validAddress = value => typeof value === 'string' && Boolean(value.trim()) && value.length <= 2000 &&
  !/[\u0000-\u001f\u007f-\u009f]/.test(value);
export function retryDeadline(response, payload) {
  if (response.status !== 429 || payload?.code !== 'DELIVERY_RATE_LIMITED') return 0;
  const raw = response.headers?.get('Retry-After');
  const seconds = typeof raw === 'string' && /^[0-9]+$/.test(raw) ? Number(raw) : NaN;
  const now = Date.now();
  const safeSeconds = Number.isSafeInteger(seconds) && seconds > 0 &&
    seconds <= Math.floor((8640000000000000 - now) / 1000);
  return now + (safeSeconds ? seconds : 60) * 1000;
}
// Validate the calendar before Date.parse can normalize an impossible date.
export function parseQuoteTimestamp(value) {
  if (typeof value !== 'string') return NaN;
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d{1,6})?(Z|[+-]\d{2}:\d{2})$/.exec(value);
  if (!match) return NaN;
  const [, yearText, monthText, dayText, hourText, minuteText, secondText, zone] = match;
  const [year, month, day, hour, minute, second] = [yearText, monthText, dayText, hourText, minuteText, secondText].map(Number);
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (month < 1 || month > 12 || day < 1 || day > days[month - 1] || hour > 23 || minute > 59 || second > 59) return NaN;
  if (zone !== 'Z' && (Number(zone.slice(1, 3)) > 23 || Number(zone.slice(4, 6)) > 59)) return NaN;
  const instant = Date.parse(value);
  return Number.isFinite(instant) ? instant : NaN;
}
function newSession() {
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
}

export default function DeliveryAddressPicker({ base, restaurantId, onDestinationChange, cooldownUntil, onCooldown, language = 'en' }) {
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [status, setStatus] = useState('idle');
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  const [activeIndex, setActiveIndex] = useState(-1);
  const session = useRef(null);
  const generation = useRef(0);
  const controller = useRef(null);
  const accepted = useRef(false);
  const requiresRetry = useRef(false);
  const finalizing = useRef(false);
  const invalidateWork = () => { generation.current += 1; controller.current?.abort(); };

  useEffect(() => () => { generation.current += 1; controller.current?.abort(); }, []);
  useEffect(() => {
    if (requiresRetry.current || accepted.current || finalizing.current || query.trim().length < 3 || Date.now() < cooldownUntil) return;
    const revision = ++generation.current;
    const abort = new AbortController();
    controller.current = abort;
    const timer = setTimeout(async () => {
      setStatus('searching');
      setError('');
      try {
        session.current ||= newSession();
        const response = await fetch(base + '/delivery/autocomplete', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: abort.signal,
          body: JSON.stringify({ query: query.trim(), session_token: session.current }),
        });
        const payload = await response.json();
        // Rate limits apply to the client even when this search is obsolete.
        const deadline = retryDeadline(response, payload);
        if (deadline) onCooldown(deadline);
        if (generation.current !== revision || abort.signal.aborted) return;
        if (deadline) requiresRetry.current = true;
        if (!response.ok) throw new Error(deliveryErrorMessage(payload?.code));
        if (!Array.isArray(payload?.suggestions) || payload.suggestions.length > 5 ||
            !payload.suggestions.every(item => validPlaceId(item?.place_id) && validAddress(item?.text))) {
          throw new Error('Address suggestions could not be verified. Try again.');
        }
        setSuggestions(payload.suggestions);
        setStatus(payload.suggestions.length ? 'results' : 'empty');
      } catch (failure) {
        if (generation.current !== revision || abort.signal.aborted) return;
        setSuggestions([]);
        setStatus('error');
        setError(failure.message === 'Address suggestions could not be verified. Try again.' || Object.values(messages).includes(failure.message)
          ? failure.message : 'Address search is unavailable. Please try again.');
      }
    }, 300);
    return () => { clearTimeout(timer); abort.abort(); };
  }, [query, attempt, base, cooldownUntil, onCooldown]);

  const edit = value => {
    invalidateWork();
    if (accepted.current || finalizing.current) session.current = null;
    requiresRetry.current = false;
    accepted.current = false;
    finalizing.current = false;
    onDestinationChange(null);
    setQuery(value.slice(0, 200));
    setSuggestions([]);
    setActiveIndex(-1);
    setStatus('idle');
    setError('');
  };
  const select = async suggestion => {
    if (Date.now() < cooldownUntil || !session.current || finalizing.current) return;
    invalidateWork();
    const revision = generation.current;
    const abort = new AbortController();
    controller.current = abort;
    const token = session.current;
    session.current = null;
    finalizing.current = true;
    onDestinationChange(null);
    setSuggestions([]);
    setActiveIndex(-1);
    setStatus('finalizing');
    setError('');
    try {
      const response = await fetch(base + '/delivery/destination', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: abort.signal,
        body: JSON.stringify({ delivery_place_id: suggestion.place_id, session_token: token }),
      });
      const payload = await response.json();
      const deadline = retryDeadline(response, payload);
      if (deadline) onCooldown(deadline);
      if (generation.current !== revision || abort.signal.aborted) return;
      if (deadline) requiresRetry.current = true;
      if (!response.ok) throw new Error(deliveryErrorMessage(payload?.code));
      if (!validPlaceId(payload?.delivery_place_id) || payload.delivery_place_id !== suggestion.place_id ||
          !validAddress(payload.delivery_address)) throw new Error(messages.INVALID_PLACE_DETAILS);
      accepted.current = true;
      setQuery(payload.delivery_address);
      setStatus('accepted');
      onDestinationChange({ placeId: payload.delivery_place_id, canonicalAddress: payload.delivery_address, restaurantId });
    } catch (failure) {
      if (generation.current !== revision || abort.signal.aborted) return;
      setStatus('error');
      setError(Object.values(messages).includes(failure.message) ? failure.message : 'The address could not be verified. Search again.');
    } finally {
      if (generation.current === revision) finalizing.current = false;
    }
  };
  const cooling = Date.now() < cooldownUntil;
  const ui = PICKER_COPY[language] || PICKER_COPY.en;
  return <section aria-label={ui.address} className="mt-4 space-y-2">
    <label htmlFor="delivery-address" className="block font-semibold">{ui.address}</label>
    <input id="delivery-address" role="combobox" aria-autocomplete="list" aria-expanded={suggestions.length > 0}
      aria-controls="delivery-suggestions" aria-activedescendant={activeIndex >= 0 ? 'delivery-option-' + activeIndex : undefined}
      aria-describedby="delivery-address-status" autoComplete="off" value={query}
      onChange={event => edit(event.target.value)}
      onKeyDown={event => {
        if (event.key === 'ArrowDown' && suggestions.length) { event.preventDefault(); setActiveIndex(i => (i + 1) % suggestions.length); }
        if (event.key === 'ArrowUp' && suggestions.length) { event.preventDefault(); setActiveIndex(i => (i - 1 + suggestions.length) % suggestions.length); }
        if (event.key === 'Escape') { setSuggestions([]); setActiveIndex(-1); }
        if (event.key === 'Enter') { event.preventDefault(); if (activeIndex >= 0 && suggestions[activeIndex]) select(suggestions[activeIndex]); }
      }} className="min-h-[48px] w-full rounded-xl border border-input bg-background px-3" />
    <ul id="delivery-suggestions" role="listbox">
      {suggestions.map((suggestion, index) => <li key={suggestion.place_id + ':' + index} role="option"
        id={'delivery-option-' + index} aria-selected={activeIndex === index}>
        <button type="button" disabled={cooling} className="min-h-[44px] w-full p-2 text-left"
          onClick={() => select(suggestion)}>{suggestion.text}</button>
      </li>)}
    </ul>
    <p id="delivery-address-status" role="status">
      {cooling ? ui.cooling : status === 'searching' ? ui.searching :
        status === 'finalizing' ? ui.finalizing : status === 'accepted' ? ui.accepted :
        status === 'empty' ? ui.empty : ui.prompt}
    </p>
    {error && <p role="alert">{localizedPickerError(error, language)}</p>}
    {status === 'error' && <button type="button" disabled={cooling} onClick={() => {
      requiresRetry.current = false; setError(''); setStatus('idle'); setAttempt(value => value + 1);
    }}>{ui.retry}</button>}
  </section>;
}
